import { createAction } from "@reduxjs/toolkit";

import { SaveReferralPayload } from "./types";

export const saveReferral = createAction<SaveReferralPayload>("saveReferral");

export const getReferral = createAction("getReferral");
